import { Nav } from "@/components/site/Nav";
import { Marquee } from "@/components/site/Marquee";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { NitricHero } from "@/components/nitric/NitricHero";
import { NitricWhy } from "@/components/nitric/NitricSections";
import { NitricIngredients, NitricQuotes } from "@/components/nitric/NitricContent";
import { NitricPricing } from "@/components/nitric/NitricPricing";

const LINKS = [["Why", "#why"], ["Ingredients", "#ingredients"], ["Offer", "#offer"], ["FAQ", "#faq"]];
const MARQUEE = ["Vegan", "Dairy free", "GMP certified", "Non-GMO", "Made in USA", "Non-habit forming"];
const QA = [
  ["What is Nitric Boost?", "A powdered supplement designed to support sexual performance naturally by helping your body make nitric oxide and support healthy blood flow."],
  ["How do I take it?", "The maker recommends one scoop of the powder per day. Follow the directions on the label."],
  ["What's in it?", "Beet Root Powder, L-Arginine, L-Citrulline DL-Malate, Niacin (Vitamin B3), Horny Goat Weed, Ginkgo Biloba, Dong Quai and D-Aspartic Acid."],
  ["How much does it cost?", "On the official site: 1 jar $69 + shipping, 3 jars $59 each ($177) and 6 jars $49 each ($294). The 3 and 6 jar packs include free USA shipping and 2 bonuses."],
  ["Is there a money-back guarantee?", "Yes — the maker offers a 60-day, 100% money-back guarantee on any order size. Contact their support team to request a refund."],
  ["Is Nitric Boost safe?", "The maker says it is made in the USA in a GMP-certified facility and is vegan, dairy-free and non-GMO. Always consult your doctor first, especially if you take heart or blood-pressure medication."],
];
const HEADLINE = <>Your move, <span className="font-serif italic font-normal text-[#FF4D4D]">your pace.</span></>;

export default function NitricBoost() {
  return (
    <main className="bg-[#140A0C]" data-testid="nitric-boost-page">
      <Nav product="nitric-boost" links={LINKS} />
      <NitricHero />
      <Marquee items={MARQUEE} dot="#FF4D4D" />
      <NitricWhy />
      <NitricIngredients />
      <NitricQuotes />
      <NitricPricing />
      <Faq items={QA} />
      <Footer product="nitric-boost" headline={HEADLINE} />
    </main>
  );
}
